import React from 'react';
import { connect } from 'react-redux';
import { GALLERY_TYPES } from '../../../constants/proGalleryConstants';
import { LOADING_MEDIAS_HEIGHT } from '../../../constants';
import { ProGallery } from '../common/index';

// Actions
import { eventsListenerProGallery } from '../../../actions/proGalleryActions';

// Style
import { st, classes } from './feed.st.css';

const Feed = ({
  eventsListenerProGallery,
  medias,
  mediaLinksMap,
  galleryHeight,
  heightShowMoreNeedToRemove,
  isLoadingMedias,
  isMobile,
  isV4Styles,
}) => (
  <div className={st(classes.root, { isV4Styles })}>
    <ProGallery
      eventsListener={eventsListenerProGallery}
      items={medias}
      mediaLinksMap={mediaLinksMap}
      galleryHeight={galleryHeight}
      heightShowMoreNeedToRemove={heightShowMoreNeedToRemove}
      isLoadingItems={isLoadingMedias}
      isMobile={isMobile}
      type={GALLERY_TYPES.FEED}
      loadingHeight={LOADING_MEDIAS_HEIGHT}
    />
  </div>
);

const mapStateToProps = (state) => ({
  isLoadingMedias: state.appReducer.isLoadingMedias,
  medias: state.appReducer.medias,
  mediaLinksMap: state.appReducer.mediaLinksMap,
  galleryHeight: state.galleryReducer.feed.height,
  heightShowMoreNeedToRemove:
    state.galleryReducer.feed.heightShowMoreNeedToRemove,
  cornerRadiusFeed: state.settingsReducer.cornerRadiusFeed,
  isDisplayImagesFeed: state.settingsReducer.isDisplayImagesFeed,
  isV4Styles: state.settingsReducer.isV4Styles,
  feedLayoutType: state.settingsReducer.layoutType,
  direction: state.settingsReducer.direction,
});

const mapDispatchToProps = (dispatch) => ({
  eventsListenerProGallery: (eName, eData, type) =>
    dispatch(eventsListenerProGallery(eName, eData, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Feed);
